import { createFileRoute } from "@tanstack/react-router";
import { ArticleLayout } from "@/components/article-layout";
import { tutorialSections } from "@/lib/tutorials-data";

// No head() here: this is the shared layout for both /tutorials (index) and
// /tutorials/$slug. Emitting SEO/canonical at the layout level would add a
// second <link rel="canonical"> (to /tutorials) on every child page on top of
// the child's own canonical. Per-page SEO lives in the index and $slug routes.
export const Route = createFileRoute("/tutorials")({
  component: TutorialsLayout,
});

function TutorialsLayout() {
  return (
    <ArticleLayout
      areaLabel="Tutorials"
      base="/tutorials"
      articleRoute="/tutorials/$slug"
      groups={tutorialSections.map((s) => ({ title: s.title, items: s.articles }))}
    />
  );
}
